import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';

import { getLocalUserId, useLogout } from 'src/features/auth';
import { useGetUser } from 'src/features/profile/api/useGetUser';
import ProfileInfoForm from 'src/features/profile/components/ProfileInfoForm';
import ProfileLayout from 'src/features/profile/components/ProfileLayout';
import { detailsMessages } from 'src/features/profile/utils';
import GeneralMessageBlock from 'src/registry/components/blocks/GeneralMessageBlock';
import {
    SectionBlock,
    SectionBlockHeader,
    SectionBlockHead,
    SectionBlockTitle,
    SectionBlockSubtitle,
    SectionBlockSeparator,
    SectionBlockBody,
} from 'src/registry/components/blocks/SectionBlock';
import { Button } from 'src/registry/ui/Button';
import { Skeleton } from 'src/registry/ui/Skeleton';

const Details = () => {
    const { formatMessage } = useIntl();
    const userId = getLocalUserId();

    const { data, isLoading, isError, refetch } = useGetUser({
        userId,
        config: { enabled: !!userId },
    });

    const { mutate: logout } = useLogout({
        onSuccess: () => {
            window.location.reload();
        },
    });

    return (
        <ProfileLayout>
            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>{formatMessage(detailsMessages.personalInfoTitle)}</SectionBlockTitle>
                        <SectionBlockSubtitle>
                            {formatMessage(detailsMessages.personalInfoSubtitle)}
                        </SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody>
                    {isLoading && (
                        <div>
                            <Skeleton className="mt-4 h-12 w-full" />
                            <Skeleton className="mt-4 h-12 w-full" />
                            <Skeleton className="mt-4 h-12 w-full" />
                        </div>
                    )}
                    {isError && <GeneralMessageBlock variant="error" icon={faCircleExclamation} />}
                    {data && <ProfileInfoForm userId={userId} data={data} refetch={refetch} />}
                </SectionBlockBody>
            </SectionBlock>
            <SectionBlock>
                <SectionBlockSeparator />
                <div className="flex justify-end">
                    <Button variant="destructive" onClick={() => logout(undefined)}>
                        {formatMessage(detailsMessages.logout)}
                    </Button>
                </div>
            </SectionBlock>
        </ProfileLayout>
    );
};

export default Details;
